import React from "react";
import {Icon, Layout} from "antd";
import {imageUrlPath} from "../Settings";
import DetailsTabs from "./Tabs/DetailsTabs";
import useDetails from "./useDetails";
import Preview from "../Preview/Preview";
import "./Details.css";

const {Header, Sider, Content, Footer} = Layout;
const Details = () => {
	const {asideHidden, preflightReport, admaterial, setAsideHidden} = useDetails();

	if (!admaterial || !preflightReport) return null;
	const previewUrl = admaterial.bigpreview? admaterial.bigpreview.url: admaterial.preview.url;
	return (
		<div id="details">
			<Layout>
				<Sider trigger={null} collapsible collapsed={asideHidden}>
					<DetailsTabs/>
				</Sider>
				<Layout>
					<Header style={{background: "#FFF", padding: 0}}>
						<Icon className="trigger" type={asideHidden? "menu-unfold": "menu-fold"} onClick={() => setAsideHidden(!asideHidden)}/>
					</Header>
					<Content>
						<Preview src={imageUrlPath + previewUrl}/>
					</Content>
					<Footer>Footer</Footer>
				</Layout>
			</Layout>
		</div>
	);
};

export default Details;


// WEBPACK FOOTER //
// ./src/components/Details/Details.js